import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import axios from "axios";

const ChangePassword = (props) => {
  const { dropdown } = props;
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;

      const passResponse = await axios.post(
        `${apiUrl}/api/v1/change-password`,
        {
          current_password: currentPassword,
          new_password: newPassword,
          new_password_confirmation: confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (passResponse.data?.message) {
        toast.success(passResponse.data.message, {
          theme: "colored",
          autoClose: 1000,
        });
        // navigate(`/admin/dashboard`);
        // dropdown();
      }
    } catch (error) {
      const responseData = error?.response?.data;

      if (responseData?.error) {
        toast.error(responseData.error, { theme: "colored", autoClose: 1000 });
      } else if (responseData?.errors) {
        const errors = responseData.errors;

        Object.keys(errors).forEach((key) => {
          errors[key].forEach((message) => {
            toast.error(message, { theme: "colored", autoClose: 1000 });
          });
        });
      } else {
        toast.error(
          responseData?.message || "Something went wrong.",
          { theme: "colored", autoClose: 1000 }
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    if (localStorage.getItem('Role') === 'restaurant') {
      navigate(`/restaurantPanel/dashboard/${localStorage.getItem("currentRestId") ? localStorage.getItem("currentRestId") : 5231}`);
      dropdown();
    } else {
      navigate(`/admin/dashboard`);
      dropdown();
    }
  };

  return (
    <>
      <section className="border-t border-[#D9D9D9] md:mt-5 md:pt-10 pt-5">
        <h3 className="md:ext-2xl text-2xl font-bold mb-5 poppins-medium">Cambiare la password</h3>
        <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5 border-[2px] border-[#8B24332B] sm:p-10 p-5 rounded-xl shadow-md font-sans">
          <div className="flex flex-col space-y-4 mb-4">
            <div className="flex md:flex-row flex-col gap-6">
              <div className="flex flex-col md:w-full w-full space-y-3 relative">
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Password attuale:
                </label>
                <div className="relative w-full">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute top-1/2 right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  >
                    {showCurrentPassword ? <FaRegEyeSlash color="404040" /> : <FaRegEye color="404040" />}
                  </button>
                </div>
              </div>
            </div>
            <div className="flex md:flex-row flex-col gap-6">
              <div className="flex flex-col md:w-full w-full space-y-3 relative">
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Nuova Password:
                </label>
                <div className="relative w-full">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute top-1/2 right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? <FaRegEyeSlash color="404040" /> : <FaRegEye color="404040" />}
                  </button>
                </div>
              </div>
            </div>
            <div className="flex md:flex-row flex-col gap-6">
              <div className="flex flex-col md:w-full w-full space-y-3 relative">
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Conferma Password:
                </label>
                <div className="relative w-full">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="poppins-regular w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute top-1/2 right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaRegEyeSlash color="404040" /> : <FaRegEye color="404040" />}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-10">
            {isLoading ? (
              <button disabled type="button"
                className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
                <svg
                  aria-hidden="true"
                  className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                Loading...
              </button>
            ) : (
              <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                onClick={handleSave}
              >
                <TiTick size={"25px"} color="green" />
                <span className="poppins-regular">Aggiorna</span>
              </button>
            )}
            {/* <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={handleCancel}
            >
              <IoClose size={"25px"} color="red" className="group-hover:invert" />
              <span className="poppins-regular">Annulla</span>
            </button> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default ChangePassword;
